import React from 'react';
import PropTypes from 'prop-types';

export default function AccountPortlet({
  id = 'account-portlet',
  title,
  titleDesc,
  body,
}) {
  return (
    <>
      <div className="row" id={id}>
        <div className="col-12">
          <h5>{title}</h5>
        </div>
      </div>
      {titleDesc && (
        <div className="row kt-margin-b-10">
          <div className="col-12">
            <span className="kt-section__info " style={{color: '#646c9a'}}>
              {titleDesc}
            </span>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-12">{body}</div>
      </div>
    </>
  );
}

AccountPortlet.propTypes = {
  title: PropTypes.node,
  titleDesc: PropTypes.node,
  body: PropTypes.node,
};
